var _path, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 33.867 33.867",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.26458)",
    fontFamily: "'Fredoka One'",
    fontSize: "13.333px",
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: 1.15,
      shapeInside: "url(#rect3128)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 32.245 25.42-23.713-2.6534 4.7356 4.9641-2.1964-2.6534 4.7356 4.9641-2.1964-3.2025 3.4946-20.428 20.91-4.3864 2.8312 2.6534-4.7356-4.9641 2.1964 2.6534-4.7356-4.9641 2.1964",
    fill: "#666",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 20,
    strokeWidth: 0.6069
  })), /*#__PURE__*/React.createElement("text", {
    x: 576.35944,
    y: 284.4422,
    fontFamily: "sans-serif",
    fontSize: "25.4px",
    letterSpacing: "0px",
    strokeWidth: 0.26458,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 576.35944,
    y: 284.4422,
    strokeWidth: 0.26458
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.a5020993239efd8a7dbd7585b05d15b7.svg";
export { ForwardRef as ReactComponent };